/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React from "react";
import Select from "./common/Select.vue";
import { useDtfStore } from "./store";
import { useSpanglesStore } from "./spangles-module";
import "./DtfSpanglesColorSelector.scss";
import { renderList } from "common/vue/render-list";
import { cn } from "tailwind-variants";

export default function DtfSpanglesColorSelector(props: any) {
  const { ...restProps } = props;
  const store = useDtfStore();
  const spanglesStore = useSpanglesStore();

  function spangleColors() {
    // @ts-expect-error TS(4111): Property 'spangleColors' comes from an index signa... Remove this comment to see the full error message
    return store.spangleColors;
  }

  function selectedVersion() {
    // @ts-expect-error TS(4111): Property 'selectedVersion' comes from an index sig... Remove this comment to see the full error message
    return spanglesStore.selectedVersion;
  }

  function allAPIsCompleted() {
    // @ts-expect-error TS(4111): Property 'allAPIsCompleted' comes from an index si... Remove this comment to see the full error message
    return spanglesStore.allAPIsCompleted;
  }

  function disabled() {
    return (
      !selectedVersion() ||
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      selectedVersion()?.isLoading ||
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      selectedVersion()?.error ||
      !allAPIsCompleted()
    );
  }

  function colorOptions() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return spangleColors().map((color: any) => ({
      value: `[${color.rgbCode}]`,
      label: color.name,
      prefix: color.imageUrl,
      labelSuffix: color.spangleCode
    }));
  }

  function colorValues() {
    if (disabled()) {
      return [];
    }
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (!selectedVersion() || !selectedVersion().spanglePagesInfo) {
      return [];
    }
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return Object.values(selectedVersion().spanglePagesInfo).filter(
      color => typeof color === "object"
    );
  }

  function changeColor(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return spanglesStore.changeColor(...args);
  }

  function getColorValue({ color }: any) {
    return colorOptions().find((colorValue: any) => colorValue.value === JSON.stringify(color));
  }

  function selectColor(index: any, color: any) {
    const values = colorValues();
    values[index] = {
      ...values[index],
      color: JSON.parse(color)
    };
    changeColor({
      colorValues: values.reduce(
        (acc, value, trayIndex) => ({
          ...acc,
          [`tray_${trayIndex}`]: value
        }),
        {}
      )
    });
  }

  const colorValuesList = colorValues();

  return (
    <>
      {colorValuesList.length > 0 ? (
        <div {...restProps} className={cn("spangle-color-selector scope-e57dfa67")}>
          <div className={cn("spangle-color-selector__header scope-e57dfa67")}>
            Select spangles colors
          </div>
          <div className={cn("spangle-color-selector__color-container scope-e57dfa67")}>
            {renderList(colorValuesList, (color, index) => (
              <div className={cn("spangle-color-selector__color scope-e57dfa67")} key={color.value}>
                <span className={cn("spangle-color-selector__color-number scope-e57dfa67")}>
                  Color #{index + 1}
                </span>
                <Select
                  className={cn("scope-e57dfa67")}
                  disabled={disabled()}
                  value={getColorValue(color)}
                  options={colorOptions()}
                  placeholder={"Select a color"}
                  // @ts-expect-error TS(2322): Type '(e: any) => void' is not assignable to type ... Remove this comment to see the full error message
                  onChange={(e: any) => {
                    selectColor(index, e);
                  }}
                  data-testid="select"
                />
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </>
  );
}
